module.exports = __webpack_public_path__ + "img/eingangsportal.088d199a.webp";